import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRouter from "./router/AppRouter";
import { setAccount, setToken } from "./reducer/userReducer";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

function App() {
   const dispatch = useDispatch()

   useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const account = localStorage.getItem("account");
    const token = localStorage.getItem("token")

    if (accessToken){
      dispatch(setToken(accessToken))
    }
    if (token){
      dispatch((setToken(token)))
    }
    if (account){
      dispatch(setAccount(JSON.parse(account)))
    }
   },[dispatch])

  return (
    <>
      <AppRouter />
      <ToastContainer />
    </>
  );
}

export default App;
